import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { eAreaType } from 'src/app/entity/enum/enum-area-type';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';
import { FormularioService } from 'src/app/services/formulario.service';
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from 'src/app/services/notification.service';
import { GeneralComponent } from 'src/app/shared/general.component';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-cd001-card-classificacao-VI',
  templateUrl: './cd001-card-classificacao-VI.component.html',
})
export class Cd001CardClassificacaoVIComponent
  extends GeneralComponent
  implements OnInit {
  public formulario?: FormGroup;

  public listPreviaNumeroPassada?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listRegulagemPasse?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listLiberacaoEspecial?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

  public listPreviaNumeroPassadaOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listRegulagemPasseOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listLiberacaoEspecialOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  msgAvisoPasse = ""
  msgAvisoRegulagem = ""




  @Output() mkCalc = new EventEmitter();
  @Output() generationChoose = new EventEmitter();
  public ngSelectedliberacaoEspecial = 'NÃO'

  area: string = eAreaType.commercial;

  // tslint:disable-next-line: max-line-length
  constructor(
    protected formularioService: FormularioService,
    protected formBuilder: FormBuilder,
    protected notificationService: NotificationService,
    protected generalService: GeneralService,
    private route: ActivatedRoute
  ) {
    super('Avaliação Geral', false);
    if (this.isBasica) {
      this.formulario = this.formBuilder.group({
        responsavel_analise: [null, [Validators.required]],
        previa_numero_passada_basica: [null, [Validators.required]],
        regulagem_passe: [null, [Validators.required]],
        liberacao_especial: [null, [Validators.required]],
        motivo_liberacao_especial: [{ value: null, disabled: true }, []],
        responsavel_autorizacao_especial: [{ value: null, disabled: true }, []],
        avaliacao_retencao: [null, []],
        avaliacao_precision_planting: [null, []],
        usuario: [null, []],
        criado_por: [null, []],
      });

    }
    else {
      this.formulario = this.formBuilder.group({
        // responsavel_analise: [null, [Validators.required]],
        // previa_numero_passada_basica: [null, [Validators.required]],
        // regulagem_passe: [null, [Validators.required]],
        // liberacao_especial: [null, [Validators.required]],
        // motivo_liberacao_especial: [{ value: null, disabled: true }, []],
        // responsavel_autorizacao_especial: [{ value: null, disabled: true }, []],
        // avaliacao_retencao: [null, []],
        // avaliacao_precision_planting: [null, []]
      });
    }

    //this.formulario.controls.basic.disable();
    //this.formulario.controls.generation_id.disable();
    //this.formulario.controls.porcentagem_falha.disable();
    //this.formulario.controls.vazao.disable();
    //this.formulario.controls.responsavel_especial.disable();
  }

  public async ngOnInit(): Promise<void> {
    await this.getLists();
    this.disableInputs();
    this.changeSelect(null)
  }

  public changeCollapse(): void {
    this.collapseCard = this.collapseCard ? false : true;
  }

  public hasErrorFormControl(campoFormulario?: AbstractControl): string {
    return this.formularioService.hasErrorFormControl(campoFormulario);
  }

  public async makeCalculations(): Promise<void> {
    this.mkCalc.emit();
  }


  async getLists(): Promise<void> {
    await Promise.all([
      this.getlistPreviaNumeroPassada(),
      this.getlistRegulagemPasse(),
      this.getlistLiberacaoEspecial()
    ]);
  }


  async getlistPreviaNumeroPassada(): Promise<void> {
    await this.formularioService.getListDropDownList('cd001_classificacao', 'previa_numero_passada_basica').pipe(take(1)).toPromise().then(response => {
      if (!!response?.data) {
        this.listPreviaNumeroPassada = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
        this.listPreviaNumeroPassadaOriginal = this.listPreviaNumeroPassada;
      }
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorPeneira);
    });
  }

  async getlistRegulagemPasse(): Promise<void> {
    await this.formularioService.getListDropDownList('cd001_classificacao', 'regulagem_passe').pipe(take(1)).toPromise().then(response => {
      if (!!response?.data) {
        this.listRegulagemPasse = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
        this.listRegulagemPasseOriginal = this.listRegulagemPasse;
      }
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorPeneira);
    });
  }

  async getlistLiberacaoEspecial(): Promise<void> {
    await this.formularioService.getListDropDownList('cd001_classificacao', 'liberacao_especial').pipe(take(1)).toPromise().then(response => {
      if (!!response?.data) {
        this.listLiberacaoEspecial = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
        this.listLiberacaoEspecialOriginal = this.listLiberacaoEspecial;
      }
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorPeneira);
    });
  }


  //desabilitar responsavel analise caso liberação especial = 'NÃO'
  disableInputs = () => {
    //if(this.listLiberacaoEspecial.values  = 'NÃO'){

    //}

    // this.formulario.controls.responsavel_analise.disable();
  }

  generationChange = (event: MatSelectChange) => {
    this.generationChoose.emit(event.value);
  }


  changeSelect(event) {
    const value = this.formulario.get("liberacao_especial")?.value as string
    if (value == "SIM") {
      this.formulario.get("motivo_liberacao_especial")?.enable()
      this.formulario.get("motivo_liberacao_especial")?.setValidators(Validators.required)
      this.formulario.get("responsavel_autorizacao_especial")?.enable()
      this.formulario.get("motivo_liberacao_especial")?.updateValueAndValidity()

    }
    else {
      this.formulario.get("motivo_liberacao_especial")?.setValue(null)
      this.formulario.get("motivo_liberacao_especial")?.disable()
      this.formulario.get("motivo_liberacao_especial")?.clearValidators()
      this.formulario.get("motivo_liberacao_especial")?.updateValueAndValidity()
      this.formulario.get("responsavel_autorizacao_especial")?.setValue(null)
      this.formulario.get("responsavel_autorizacao_especial")?.disable()
      this.formulario.get("responsavel_autorizacao_especial")?.clearValidators()
    }
  }

  changePasseOrRegulagem() {
    const valuePasse = this.formulario.get("previa_numero_passada_basica")?.value as string
    const valueRegulagem = this.formulario.get("regulagem_passe")?.value as string


    if (valuePasse != "1º PASSE" && valuePasse != null) {
      this.msgAvisoPasse = "Número do Passe tem seguir a sequência numérica"
    }
    if (valueRegulagem != "1º REGULAGEM" && valueRegulagem != null) {
      this.msgAvisoRegulagem = "Número de Regulagens tem seguir a sequência numérica"
    }

  }

  createFilterPreviaNumeroPassada(value: string): void {
      this.listPreviaNumeroPassada = this.generalService.applyFilter(value, this.listPreviaNumeroPassadaOriginal, this.listPreviaNumeroPassada);
  }

  createFilterRegulagemPasse(value: string): void {
      this.listRegulagemPasse = this.generalService.applyFilter(value, this.listRegulagemPasseOriginal, this.listRegulagemPasse);
  }

  createFilterLiberacaoEspecial(value: string): void {
      this.listLiberacaoEspecial = this.generalService.applyFilter(value, this.listLiberacaoEspecialOriginal, this.listLiberacaoEspecial);
  }
}
